import { Action } from '@ngrx/store';
import { NextWorkingDayRequest, NextWorkingDayRequestV5, NextWorkingDayResponseV5 } from '@cemex-core/cmx-api';

export enum NextWorkingDayActionTypes {
  RESET = '[NextWorkingDay] Reset',
  LOAD = '[NextWorkingDay] Load Load Next Working Day',
  LOAD_CUT_OF_TIME = '[NextWorkingDay] Load Cut of time V5',
  LOAD_COMPLETE = '[NextWorkingDay] Complete Load Next Working Day',
  LOAD_COMPLETE_ERROR = '[NextWorkingDay] Complete Load Next Working Day Error',
  LOAD_CUT_OF_TIME_COMPLETE = '[NextWorkingDay] Complete Load Cut of time V5',
  LOAD_CUT_OF_TIME_MODIFY = '[NextWorkingDay] Load Cut of time V5 MODIFY',
}

export class LoadNextWorkingDayAction implements Action {
  readonly type = NextWorkingDayActionTypes.LOAD;

  constructor(public payload: NextWorkingDayRequest) {}
}

export class LoadNextWorkingDayActionV5 implements Action {
  readonly type = NextWorkingDayActionTypes.LOAD_CUT_OF_TIME;

  constructor(public payload: NextWorkingDayRequestV5) {}
}

export class LoadNextWorkingDayModifyActionV5 implements Action {
  readonly type = NextWorkingDayActionTypes.LOAD_CUT_OF_TIME_MODIFY;

  constructor(public payload: NextWorkingDayRequestV5) {}
}

export class LoadNextWorkingDayCompleteAction implements Action {
  readonly type = NextWorkingDayActionTypes.LOAD_COMPLETE;

  constructor(
    public payload: {
      date: Date;
      blackout?: any;
      timeCut?: string;
      timezone?: {
        links: {
          self: string;
        };
        timeZoneId: number;
        iANACode: string;
        windowsCode: string;
        timeOffset: string;
      };
    },
  ) {}
}

export class LoadNextWorkingDayCompleteActionError implements Action {
  readonly type = NextWorkingDayActionTypes.LOAD_COMPLETE_ERROR;
}

export class LoadNextWorkingDayCompleteActionV5 implements Action {
  readonly type = NextWorkingDayActionTypes.LOAD_CUT_OF_TIME_COMPLETE;

  constructor(public payload: NextWorkingDayResponseV5) {}
}

export class ResetNextWorkingDayAction implements Action {
  readonly type = NextWorkingDayActionTypes.RESET;

  constructor() {}
}

export type NextWorkingDayActionActions =
  | LoadNextWorkingDayCompleteAction
  | ResetNextWorkingDayAction
  | LoadNextWorkingDayAction
  | LoadNextWorkingDayActionV5
  | LoadNextWorkingDayCompleteActionV5
  | LoadNextWorkingDayCompleteActionError;
